import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { AircraftStore } from '../aircraft.store';
import { RoutingInfoComponent } from '../routing-info/routing-info.component';
import { LegView } from '@sequence/models/view/leg.view';
import { RequestState } from '@shared/models/request-state';
import { MelView } from '@shared/models/mel.view';
import { Observable } from 'rxjs';
import { AircraftRoutingView } from '../models/aircraft-routing.view';
import { AircraftDetailsView } from '../models/aircraft-details.view';

@Component({
  selector: 'app-aircraft-card',
  templateUrl: './aircraft-card.component.html',
  styleUrls: ['./aircraft-card.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AircraftCardComponent implements OnChanges {
  @Input() flightState?: LegView;

  mels$?: Observable<RequestState<MelView[]>>;
  details$?: Observable<RequestState<AircraftDetailsView>>;
  routing$?: Observable<RequestState<AircraftRoutingView>>;

  routingInfoComponent = RoutingInfoComponent;

  constructor(private aircraftStore: AircraftStore) {}

  ngOnChanges(): void {
    this.loadData();
  }

  onExpanded(): void {
    this.loadData();
  }

  refresh(): void {
    this.loadData(true);
  }

  getSafeLink(aircraftNumber: string) {
    return `https://techopshub.me.aa.com/flight/${aircraftNumber}`;
  }

  private loadData(isRefresh = false): void {
    if (this.flightState) {
      this.mels$ = this.aircraftStore.getMels(this.flightState, isRefresh);
      this.details$ = this.aircraftStore.getAircraftDetails(
        this.flightState,
        isRefresh,
      );
      this.routing$ = this.aircraftStore.getRouting(
        this.flightState,
        isRefresh,
      );
    }
  }
}
